import { useState } from "react";
import { faqItems } from "@/mocks/faq";

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-secondary-100">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-foreground-800 bg-background-50 rounded-full">
            FAQ
          </span>
        </div>

        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 tracking-tight leading-tight">
          Frequently Asked Questions
        </h2>
        <p className="mt-3 text-sm text-foreground-600">
          Everything you need to know about ItaobuySpreadsheet
        </p>

        <div className="mt-10 space-y-4">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenId(openId === item.id ? null : item.id)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <span className="text-base font-semibold text-foreground-900 pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-xl text-foreground-500 flex-shrink-0 transition-transform duration-300 ${
                    openId === item.id ? "rotate-180" : ""
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === item.id ? "max-h-96 pb-5" : "max-h-0"
                }`}
              >
                <p className="px-6 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}